<template>
    <div class="success-container">
        <!-- 顶部标题栏 -->
        <div class="header">
            <div class="logo">
                <span class="logo-text">网络接入认证</span>
            </div>
            <div class="success-title">认证成功</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="success-content">
            <div class="success-card">
                <!-- 成功动画图标 -->
                <div class="success-icon">
                    <div class="circle">
                        <i class="el-icon-check"></i>
                    </div>
                </div>

                <h1 class="success-title-main">认证成功！</h1>
                <p class="success-message">您已成功接入网络，现在可以正常上网了</p>

                <!-- 设备信息卡片 -->
                <div class="info-card">
                    <div class="info-header">
                        <i class="el-icon-mobile-phone"></i>
                        <span>设备信息</span>
                    </div>
                    <div class="info-content">
                        <div class="info-item">
                            <span class="info-label">认证时间：</span>
                            <span class="info-value">{{ authTime }}</span>
                        </div>
                        <div class="info-item">
                            <span class="info-label">有效时长：</span>
                            <span class="info-value">30天</span>
                        </div>
                    </div>
                </div>

                <!-- 温馨提示 -->
                <div class="tips">
                    <i class="el-icon-info"></i>
                    温馨提示：请勿在公共网络环境中输入敏感信息，保护个人隐私安全。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Success',
        data() {
            return {
                authTime: ''  // 认证时间
            }
        },

        created() {
            this.getAuthInfo();
        },

        methods: {
            // 获取认证信息
            getAuthInfo() {
                // 获取认证时间
                const savedTime = localStorage.getItem('auth_time');
                if (savedTime) {
                    this.authTime = this.formatDateTime(new Date(savedTime));
                } else {
                    this.authTime = this.formatDateTime(new Date());
                    localStorage.setItem('auth_time', new Date().toISOString());
                }
            },

            // 格式化日期时间
            formatDateTime(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
        }
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    .success-container {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        position: relative;
    }

    .header {
        padding: 15px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
        background: rgba(0, 0, 0, 0.2);
    }

    .logo-text {
        font-size: 18px;
        font-weight: 500;
    }

    .success-title {
        font-size: 16px;
        font-weight: 500;
    }

    .success-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
    }

    .success-card {
        width: 100%;
        max-width: 500px;
        background: white;
        border-radius: 16px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        padding: 35px 30px;
        margin-bottom: 30px;
        text-align: center;
    }

    .success-icon {
        margin-bottom: 25px;
    }

    .circle {
        width: 80px;
        height: 80px;
        margin: 0 auto;
        background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        animation: scaleIn 0.5s ease-out;
    }

    .circle i {
        font-size: 40px;
        color: white;
        font-weight: bold;
    }

    @keyframes scaleIn {
        0% {
            transform: scale(0);
            opacity: 0;
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    .success-title-main {
        font-size: 28px;
        font-weight: 600;
        color: #333;
        margin-bottom: 10px;
    }

    .success-message {
        font-size: 14px;
        color: #666;
        margin-bottom: 30px;
    }

    .info-card {
        background: #f5f7fa;
        border-radius: 12px;
        padding: 15px;
        margin-bottom: 20px;
        text-align: left;
    }

    .info-header {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e7ed;
        margin-bottom: 12px;
    }

    .info-content {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .info-item {
        display: flex;
        align-items: center;
        font-size: 13px;
    }

    .info-label {
        color: #666;
        width: 80px;
    }

    .info-value {
        color: #333;
        font-weight: 500;
        flex: 1;
    }

    .tips {
        background: #fff8e6;
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 12px;
        color: #e6a23c;
        border-left: 4px solid #e6a23c;
        text-align: left;
    }

    .tips i {
        margin-right: 6px;
    }

    /* 响应式设计 */
    @media (max-width: 480px) {
        .success-card {
            padding: 25px 20px;
        }

        .success-title-main {
            font-size: 24px;
        }

        .circle {
            width: 60px;
            height: 60px;
        }

        .circle i {
            font-size: 30px;
        }
    }

    @media (max-width: 320px) {
        .success-card {
            padding: 20px 15px;
        }

        .info-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 5px;
        }

        .info-label {
            width: auto;
        }
    }
</style>